import {createContext } from "react";
const PanelContext = createContext();

export default PanelContext;